// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobileprod = {
  aws_app_analytics: 'enable',
  aws_cognito_identity_pool_id: 'us-east-1:caada608-01bb-4fc2-8f90-3f877c45726b',
  aws_cognito_region: 'us-east-1',
  aws_content_delivery: 'enable',
  aws_content_delivery_bucket: 'swasth-hosting-mobilehub-1095358790',
  aws_content_delivery_bucket_region: 'us-east-1',
  aws_content_delivery_cloudfront: 'enable',
  aws_content_delivery_cloudfront_domain: 'd171jleqy28538.cloudfront.net',
  aws_google_app_permissions: 'email,profile,openid',
  aws_google_web_app_id: '740167288482-0rtjn1h7ever08p2stu4aladqlsahfen.apps.googleusercontent.com',
  aws_mandatory_sign_in: 'enable',
  aws_mobile_analytics_app_id: 'de0cdabee11d46d48d4d7b7c79400dbf',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_project_id: '6be183be-6d25-43ae-a9e4-e10b9a1de98d',
  aws_project_name: 'swasth',
  aws_project_region: 'us-east-1',
  aws_resource_name_prefix: 'swasth-mobilehub-1095358790',
  aws_sign_in_enabled: 'enable',
  aws_user_files: 'enable',
  aws_user_files_s3_bucket: 'swasth-userfiles-mobilehub-1095358790',
  aws_user_files_s3_bucket_region: 'us-east-1',
  aws_user_pools: 'enable',
  aws_user_pools_id: 'us-east-1_8IKu6FeB5',
  aws_user_pools_mfa_type: 'OFF',
  aws_user_pools_web_client_id: '1o271vmu9tv7rb17m9cpf1nq76',
};

export default awsmobileprod;
